import React from 'react';
import Header from './common/header-component/header';
import Sidebar from './common/sidebar-component/sidebar';
import RightSidebar from './common/right-sidebar';
import Footer from './common/footer';
import ThemeCustomizer from './common/theme-customizer'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './common/loader';
import NavBar from './common/navbar';

const AppLayout = ({children}) => {
        return (
            <div>
                <Loader />
                <div className="page-wrapper page-wrapper horizontal_sidebar">
                    <div className="page-body-wrapper">
                        <Header />
                        <NavBar/>
                        {
                            (process.env.REACT_APP_SIDE_BAR === "true") && 
                            <Sidebar />
                        }
                        {
                            (process.env.REACT_APP_SIDE_BAR === "true") && 
                            <RightSidebar />
                        }
                        <div className="page-body">
                            {children}
                        </div>
                        <Footer />
                        <ThemeCustomizer />
                    </div>
                </div>
                <ToastContainer />
            </div>
        );
}

export default AppLayout;